module.exports = __webpack_public_path__ + "static/custompatio-43b6a1daf069f002cd559bb75dca2b2c.jpg";